export const CLIENT_ROUTE = '/banner';
export const API_ROUTE = '/api/banner';
export const CLIENT_TITLE = 'Баннер';